import { Component, OnInit, ChangeDetectorRef, ApplicationRef, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BaseService } from '../../../services/base.service';
import { PopupService } from '../../../services/popup.service';
import { MapService } from '../../../services/map.service';
import { UserService } from '../../../services/user.service';
import { NotificationService } from '../../../services/notification.service';
import { MyStuffService } from '../../../services/my-stuff.service';
import { LoaderService } from '../../../services/loader.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FeatureService } from '../../../services/feature.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { SegmentEvents }from '../../../constants/SegmentEvents';
import { SegmentService } from '../../../services/segment.service';

@Component({
  selector: 'app-save-map',
  templateUrl: './save-map.component.html',
  styleUrls: ['./save-map.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class SaveMapComponent implements OnInit {
	inputInterval: any;
	notes: string;
	name: string;
	saveMapForm: FormGroup;
	submitted:boolean = false;
	isSaving: boolean = false;
  saveMapChangeSubscription: Subscription;
  saveMapFeatureSubscription: Subscription;

  constructor(public popupService: PopupService, public baseService: BaseService,
   public router: Router, public mapService: MapService, public formBuilder: FormBuilder,
   public myStuffService: MyStuffService, public userService: UserService, public segmentService: SegmentService,
   public notificationService: NotificationService,
   public ref: ChangeDetectorRef, public featureService: FeatureService, public appRef: ApplicationRef,
   public loaderService: LoaderService) { }

  ngOnInit() {
    this.saveMapForm = this.formBuilder.group({
		  name: [this.name, Validators.compose([Validators.required, Validators.maxLength(59)])],
		  notes: [this.notes, Validators.compose([Validators.maxLength(1020)])]
		});
    this.initSubscriptions();
  }

  ngAfterViewInit() {
    let nameInputElement:any = document.getElementById('save-map-name-input');
    if(nameInputElement) {
      Observable.fromEvent(nameInputElement, 'input')
      .subscribe((e: any) => {
        if((nameInputElement.classList.contains('field-label-error') && nameInputElement.value.length>0) || nameInputElement.value.length === 0) {
          (<any>window).Events.publish('detectChanges');
        }
      });
    }
  }

  initSubscriptions() {
    this.saveMapChangeSubscription = this.mapService.saveMapChangeStream.subscribe((value)=>{
      this.submitted = false;
      this.name = (value)? (this.mapService.currentUserMap ?this.mapService.currentUserMap.name: this.name) : '';
      this.notes = (value)? (this.mapService.currentUserMap ?this.mapService.currentUserMap.notes: this.notes) : '';
      setTimeout(()=>{
        this.baseService.focusFirstEmptyElement('save-form-input');
      },0);
    });

    this.saveMapFeatureSubscription = this.featureService.saveMapFeatureChangeStream.subscribe((data)=>{
      if(data) {
        this.isSaving = true;
        if(this.isSaving) {
          this.loaderService.addGreyLoaderClass();
        }
        this.mapService.saveMap(data).subscribe((response: any)=>{
          this.userService.onSingleMapClick(response);
          this.myStuffService.mapEntriesAvailable[this.myStuffService.mapCallFilters.allMaps] = true;
          this.isSaving = false;
          this.closePopup();
          this.loaderService.removeGreyLoaderClass();
          this.segmentService.log(SegmentEvents.mapSaved, {
            map_id: response.id
          });
          this.notificationService.info('Your map is Saved');
          this.ref.detectChanges();
        },(error)=>{
          this.isSaving = false;
          this.loaderService.removeGreyLoaderClass();
          throw(error);
        });
      }
    });
  }

	onSubmit() {
    let w = (<any>window);
    this.submitted = true;
    if(this.saveMapForm.valid) {
      this.isSaving = true;
      this.loaderService.addGreyLoaderClass();
      w.Events.publish('detectChanges');
      if(!this.mapService.currentUserMap) {
  	    let newUserMap = {
  	      name: this.name,
  	      notes: this.notes,
  	      mapData: []
  	    };
        w.Events.publish('saveCurrentUserMap', {
          successCallback: (response) => {
            w.Events.publish('overlayFiltersChanged');
            this.userService.onSingleMapClick(response);
            this.myStuffService.mapEntriesAvailable[this.myStuffService.mapCallFilters.allMaps] = true;
            this.isSaving = false;
            this.closePopup();
            this.loaderService.removeGreyLoaderClass();
          },
          errorCallback: (error) => {
            this.isSaving = false;
            this.loaderService.removeGreyLoaderClass();
            if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
              this.featureService.updateFeature('save-map');
              this.featureService.updateExecutionFeature('save-map', newUserMap);
            }
          },
          data: newUserMap
        });
  		} else {
        w.saveMap.updateMapData();
        let updatedUserMap = {
          name: this.name,
          notes: this.notes,
          id: this.mapService.currentUserMap.id,
          mapData: []
        };
        w.saveMap.setMapDataRotateValue();
        updatedUserMap.mapData = w.saveMap.convertMapDataToKeyValue();
        this.mapService.updateMap(updatedUserMap).subscribe((response: any)=>{
          w.Events.publish('overlayFiltersChanged');
          let map = this.mapService.getSingleUserMap(response.id);
          this.isSaving = false;
          this.closePopup();
          this.mapService.userMaps.allMaps.splice(map.index, 1);
          this.mapService.userMaps.allMaps.unshift(response);
          this.mapService.currentUserMap = response;
          this.loaderService.removeGreyLoaderClass();
          this.segmentService.log(SegmentEvents.mapSaved, {
            map_id: response.id
          });
          this.notificationService.info('Your map has been updated');
          this.ref.detectChanges();
        },
        (error)=>{
          this.isSaving = false;
          this.loaderService.removeGreyLoaderClass();
          throw(error);
        });
      }
    } else {
      w.Events.publish('detectChanges');
    }
    return false;
	}

	closePopup() {
		this.saveMapForm.reset();
		this.popupService.updateRoute();
		this.submitted = false;
	}

  ngOnDestroy() {
    this.saveMapChangeSubscription && this.saveMapChangeSubscription.unsubscribe();
    this.saveMapFeatureSubscription && this.saveMapFeatureSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/save-map/save-map.component.ts